import { useState } from 'react';
import { validateEmail, validatePhone } from './validateInputs';
import { SubmissionStatus } from '../components/ResultsPage/types';

interface UsePiiValidationParams {
  phone?: string;
  email?: string;
  onProgramSubmit: () => void;
  setLeadSubmissionStatus: (status: SubmissionStatus) => void;
}

interface UsePiiValidationReturn {
  showPhoneError: boolean;
  showEmailError: boolean;
  handleSubmitClick: (e: React.FormEvent) => Promise<void>;
}

export const usePiiValidation = ({
  phone,
  email,
  onProgramSubmit,
  setLeadSubmissionStatus,
}: UsePiiValidationParams): UsePiiValidationReturn => {
  const [showPhoneError, setShowPhoneError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);

  const handleSubmitClick = async (e: React.FormEvent) => {
    let stopSubmission = false;
    e.preventDefault();

    // Clear any previous error messages
    setShowPhoneError(false);
    setShowEmailError(false);

    setLeadSubmissionStatus(SubmissionStatus.SUBMITTING);

    if (!phone) {
      setShowPhoneError(true);
      stopSubmission = true;
    }

    if (!email) {
      setShowEmailError(true);
      stopSubmission = true;
    }

    /*Phone validation*/
    if (phone && phone.length > 0) {
      const result = await validatePhone(phone);

      if (
        !result ||
        result.validPhoneNumber === false ||
        ('error' in result && result.error)
      ) {
        setShowPhoneError(true);
        stopSubmission = true;
      }
    }

    /*Email validation*/
    if (email && email.length > 0) {
      if (!validateEmail(email)) {
        setShowEmailError(true);
        stopSubmission = true;
      }
    }

    if (stopSubmission) {
      setLeadSubmissionStatus(SubmissionStatus.PENDING);
      return;
    }

    // If validation passes, call the original onProgramSubmit
    onProgramSubmit();
  };

  return {
    showPhoneError,
    showEmailError,
    handleSubmitClick,
  };
};
